module.exports = require('./helpers/bundle-url').getBundleURL('bbWiP') + "logo-dark.ba5147f0.svg";